import SelectorSet from "selector-set";

/**
 * Registers a delegate event handler on the specified element or document.
 *
 * @param {HTMLElement | Document} $element - The element or document to attach the event handler to.
 * @param {string} eventType - The type of event to listen for (e.g., 'click', 'keydown', etc.).
 * @param {string} selector - The CSS selector for the target elements within the $element.
 * @param {Function} handler - The event handler function to be executed when the event occurs.
 * @param {Boolean} capturingPhase - https://stackoverflow.com/questions/7398290/unable-to-understand-usecapture-parameter-in-addeventlistener
 * @returns {Function} - A function to remove the delegate event handler.
 */
const delegateEvent = (
    $element,
    eventType,
    selector,
    handler,
    capturingPhase = false
) => {
    const selectorSet = new SelectorSet();
    const eventHandler = (event) => {
        const $targetElement = selectorSet.matches(
            event.target
        )[0];
        if ($targetElement) {
            handler.call($targetElement, event);
        }
    };

    selectorSet.add(selector, $element);
    $element.addEventListener(eventType, eventHandler, capturingPhase);

    return () => {
        selectorSet.remove(selector, $element);
        $element.removeEventListener(eventType, eventHandler, capturingPhase);
    };
};

export { delegateEvent };
